import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      margin: 0,
      boxSizing: 'border-box',
    },
    '*': {
      padding: 0,
    },
    background: '#fff',
    padding: '0.25rem 0.5rem',
    cursor: 'pointer',
    borderRadius: '0.25rem',
    fontFamily: theme.value.typography.fontFamily,
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: theme.value.typography.fontWeight.regular,
    lineHeight: '1.25rem',
    color: theme.value.colors.gray.main,
    '&:not(&--disabled):hover': {
      background: theme.value.colors.gray.light3,
    },
    '&--disabled': {
      color: theme.value.colors.gray.light2,
      cursor: 'not-allowed',
    },
  }));

  return baseClass;
};
